import React, { useState } from "react";
import { IntlProvider } from "react-intl";
import { Formik } from "formik";

import Grid from "@material-ui/core/Grid";
import MuiThemeProvider from "@material-ui/core/styles/MuiThemeProvider";
import ForeCast from "../ForeCast";
import Product from "../Product";
import Menu from "../../components/Menu";
import HeaderDescription from "../../components/HeaderDescription";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import theme from "../../theme/theme";
import { StyledForm } from "./styles";

const initialValues = {
  marketForecast: 6.0,
  participationRate: 60,
  annualSpread: 2,
  exclude: "yes",
  resultForecast: "",
  marketForecastProduct: 4.45,
  participationRateProduct: 60,
  annualSpreadProduct: 2,
  resultProduct: ""
};

function App() {
  const [currentStep, setCurrentStep] = useState("forecast");

  const handleCurrentStep = step => {
    setCurrentStep(step);
    window.scrollTo(0, 0);
  };

  const validate = values => {
    let errors = {};
    //Forecast tab
    if (!values.marketForecast && values.marketForecast !== 0) {
      errors.marketForecast = "Required";
    } else {
      if (values.marketForecast > 25) {
        errors.marketForecast = "Max value 25.00";
      }
    }
    if (!values.participationRate && values.participationRate !== 0) {
      errors.participationRate = "Required";
    } else {
      if (values.participationRate < 1) {
        errors.participationRate = "Min 1";
      }
      if (values.participationRate > 200) {
        errors.participationRate = "Max value 200";
      }
    }

    if (!values.annualSpread && values.annualSpread !== 0) {
      errors.annualSpread = "Required";
    } else {
      if (values.annualSpread > 15) {
        errors.annualSpread = "Max value 15.0";
      }
    }
    //Product Tab
    if (!values.marketForecastProduct && values.marketForecastProduct !== 0) {
      errors.marketForecastProduct = "Required";
    } else {
      if (values.marketForecastProduct > 25) {
        errors.marketForecastProduct = "Max value 25.00";
      }
    }

    if (
      !values.participationRateProduct &&
      values.participationRateProduct !== 0
    ) {
      errors.participationRateProduct = "Required";
    } else {
      if (values.participationRateProduct < 1) {
        errors.participationRateProduct = "Min 1";
      }
      if (values.participationRateProduct > 200) {
        errors.participationRateProduct = "Max value 200";
      }
    }

    if (!values.annualSpreadProduct && values.annualSpreadProduct !== 0) {
      errors.annualSpreadProduct = "Required";
    } else {
      if (values.annualSpreadProduct > 15) {
        errors.annualSpreadProduct = "Max value 15.0";
      }
    }
    return errors;
  };
  return (
    <IntlProvider locale="en">
      <MuiThemeProvider theme={theme}>
        <Header />
        <div>
          <Grid container spacing={0} justify="center">
            <Grid item xs={11} sm={10} md={8} lg={9} xl={7}>
              <HeaderDescription currentStep={currentStep} />
            </Grid>
          </Grid>
          <Grid container spacing={0} justify="center">
            <Grid item xs={11} sm={10} md={8} lg={1} xl={1}>
              <Menu
                handleCurrentStep={handleCurrentStep}
                currentStep={currentStep}
              />
            </Grid>
            <Grid item xs={11} sm={10} md={8} lg={8} xl={6}>
              <Formik
                initialValues={initialValues}
                validate={validate}
                render={props => {
                  return (
                    <StyledForm>
                      {currentStep === "forecast" && <ForeCast {...props} />}
                      {currentStep === "product" && <Product {...props} />}
                    </StyledForm>
                  );
                }}
              />
            </Grid>
          </Grid>
          <Grid container spacing={0} justify="center">
            <Footer />
          </Grid>
        </div>
      </MuiThemeProvider>
    </IntlProvider>
  );
}

export default App;
